import React from 'react';
import { formatDateNew, formatDateTime } from '../../../../utils/commonFunctions';
import { connect } from 'react-redux';

const CallHistoryRows = ({
	call_status,
	call_time,
	row,
	isRetail,
	call_recording,
	call_type,
	call_url,
	audio_files,
}) => {
	let date = call_time.split('to');
	let startTime = date[0];
	let endTime = date[1];
	let audioPlayers = [];

	const playAudio = (e) => {
		stopAudio();
		audioPlayers.push(e.target.classList[0]);
		document.getElementById(`${e.target.classList[0]}_stop`).style.display =
			'inline-block';
		document.getElementById(`${e.target.classList[0]}_play`).style.display =
			'none';
		let audio = document.getElementById(e.target.classList[0]);
		audio.play();
	};

	const stopAudio = () => {
		let audioList = document.getElementsByTagName('audio');
		for (let i = 0; i < audioList.length; i++) {
			let id = audioList[i].id;
			let stop = document.getElementById(`${id}_stop`);
			let play = document.getElementById(`${id}_play`);
			if (!!stop) {
				stop.style.display = 'none';
			}
			if (!!play) {
				play.style.display = 'inline-block';
			}
			audioList[i].pause();
		}
	};

	const audioFiles = audio_files?.split(',')?.map((file, index) => (
		<span>
			<button
				aria-label="play"
				style={{ margin: '5px' }}
				id={`recording_${row}_${index}_play`}
				className={`recording_${row}_${index} btn btn-sm btn-info`}
				onClick={(e) => {
					playAudio(e);
				}}
				type="button"
			>
				Play Recording {audio_files?.split(',')?.length > 1 ? index + 1 : ''}
			</button>
			<button
				aria-label="stop"
				style={{ display: 'none', margin: '5px' }}
				id={`recording_${row}_${index}_stop`}
				className={`btn btn-sm btn-danger recording_${row}_${index}`}
				onClick={stopAudio}
				type="button"
			>
				Stop Recording {index + 1}
			</button>
			<audio
				style={{ display: 'none' }}
				onEnded={stopAudio}
				id={`recording_${row}_${index}`}
				controls
				controlsList="nodownload"
				src={file}
			/>
		</span>
	));

	//Call recording row logic
	let callDetails = '';
	if (!!call_status && (call_status.toLowerCase() === 'completed' || call_status.toLowerCase() === 'no show')) {
		//completed calls
		if (call_type) {
			//coach kids
			callDetails = (
				<td>
					<a href={call_url} target="_blank" rel="noopener noreferrer">
						<button
							aria-label="rewatch"
							className="btn btn-sm btn-info"
							type="button"
						>
							Re-watch Meeting
						</button>
					</a>
				</td>
			);
		} else {
			//regular coach calls
			callDetails = <td>{!audio_files ? 'N/A' : <span>{audioFiles} </span>}</td>;
		}
	} else if (!call_status) {
		//upcoming calls
		if (!call_url && call_type) {
			callDetails = <td>The meeting hasn't started yet.</td>;
		} else if (call_type) {
			callDetails = (
				<td>
					<a href={call_url} rel="noopener noreferrer" target="_blank">
						Join the Meeting
					</a>
				</td>
			);
		} else {
			callDetails = (
				<td>{!call_recording ? 'N/A' : <span>{audioFiles} </span>}</td>
			);
		}
	}

	return (
		<tr
			key={row}
			className={!call_status ? (isRetail ? 'greenBgColour' : 'greenFonts') : ''}
		>
			<td>{row + 1} </td>
			<td>{`${formatDateNew(startTime, 'D MMMM yyyy')}, ${formatDateTime(
				startTime,
				'hh:mm A',
			)} to ${formatDateTime(endTime, 'hh:mm A')}`}</td>
			<td>{!call_status ? 'Upcoming' : call_status}</td>
			{callDetails}
		</tr>
	);
};

const mapStateToProps = (state) => {
	return {
		isRetail: state.rootReducer.loginDetails.isRetail,
	};
};

export default connect(mapStateToProps)(CallHistoryRows);
